import { Field, FieldArray, Formik } from "formik";
import React from "react";
import XCancel from "../XCancel";

const initialRoomFields = {
  roomNumber: "",
  room: "",
  roomNickname: "",
  selected: true,
};

const AddNewRooms = ({ close, rooms, setRooms }) => {
  const handleSubmit = (values, formikBag) => {
    const { setSubmitting } = formikBag;
    setSubmitting(false);
    setRooms([...rooms, ...values.roomFields]);
    close();
  };

  return (
    <>
      {" "}
      <XCancel close={close} />
      <div className="px-[60px] pb-[32px] w-[300px] md:w-[632px] h-[70vh]">
        <div className="w-full h-full flex flex-col items-center justify-start">
          <p className="text-[#1A1D4D] font-black text-[16px] mb-8">Add New Rooms</p>
          <Formik onSubmit={handleSubmit} initialValues={{ roomFields: [initialRoomFields, initialRoomFields] }} validationSchema={""}>
            {({ values, handleSubmit }) => (
              <>
                <div className="flex gap-6">
                  <div className="flex gap-4 flex-col w-full">
                    <div className="grid grid-cols-12 gap-4 flex-col">
                      <p className="font-semibold text-[16px] col-span-4">Room</p>
                      <p className="font-semibold text-[16px] col-span-3">#</p>
                      <p className="font-semibold text-[16px] col-span-4">Nickname</p>
                    </div>
                    <FieldArray name="roomFields">
                      {({ push, remove }) => (
                        <div>
                          {values.roomFields.map((_, i) => {
                            return (
                              <div key={i} className="pb-6">
                                <div className="grid grid-cols-12 gap-6 flex-col items-center">
                                  <div className="col-span-4">
                                    <div className="relative flex">
                                      <Field
                                        name={`roomFields.${i}.room`}
                                        label="room"
                                        value={values.roomFields[i].room || ""}
                                        placeholder="Bedroom"
                                        className="border w-full  h-[40px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                                      />{" "}
                                    </div>
                                  </div>
                                  <div className="col-span-3">
                                    <div className="relative flex">
                                      <Field
                                        name={`roomFields.${i}.roomNumber`}
                                        label="roomNumber"
                                        value={values.roomFields[i].roomNumber || ""}
                                        placeholder="2"
                                        className="border w-full  h-[40px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                                      />{" "}
                                    </div>
                                  </div>
                                  <div className="col-span-4">
                                    <div className="relative flex">
                                      <Field
                                        name={`roomFields.${i}.roomNickname`}
                                        label="roomNickname"
                                        value={values.roomFields[i].roomNickname || ""}
                                        placeholder="Finn's Room"
                                        className="border w-full  h-[40px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                                      />{" "}
                                    </div>
                                  </div>
                                  <div>
                                    {i > 1 && (
                                      <i
                                        className="fa-solid text-red-600 fa-circle-minus ml-4 cursor-pointer text-[16px]"
                                        onClick={() => remove(i)}
                                      ></i>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          <p className="text-primary cursor-pointer font-bold text-[16px] mb-8 self-start" onClick={() => push(initialRoomFields)}>
                            Add Room Field
                          </p>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                </div>{" "}
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="w-[200px] md:w-[300px] h-[50px] bg-primary rounded mt-12 text-white text-base font-semibold"
                >
                  Save
                </button>
              </>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default AddNewRooms;
